<template>
  <v-container fill-height>
    <v-layout align-center justify-center column fill-height>
      <v-card width="100%" min-height="300" v-if="error">
        <v-card-title
          class="headline">Please wait, try refresh page each minute
          <v-spacer></v-spacer>
          <v-icon>error</v-icon>
        </v-card-title>
        
      </v-card>
      <v-card width="100%" min-height="300" v-else>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn  v-on="on" pa-3 fab @click="startUpdate" absolute right bottom :loading="loading">
              <v-icon>sync</v-icon>
            </v-btn>
          </template>
          {{loading ? $t('system.update.checking-for-update') : $t('system.update.check-for-update')}}
        </v-tooltip>

        <v-card-title
          class="headline"
          v-if="listUpgradable == null || listUpgradable.length == 0"
        >
        <v-icon large v-if="!loading" color="green">done</v-icon>
        {{loading ? $t('system.update.checking-for-update') : $t('system.update.up-to-date')}}</v-card-title>
        <v-data-table
          v-else
          :headers="headers"
          :items="listUpgradable"
          class="elevation-1"
          hide-actions
        >
          <template v-slot:items="props">
            <td>
              <v-icon>{{iconByStatus(props.item.status)}}</v-icon>
            </td>
            <td>{{props.item.name}}</td>
            <td>{{props.item.old}}</td>
            <td>{{props.item.new}}</td>
          </template>
        </v-data-table>
      </v-card>
      <v-flex ma-5 shrink v-if="listUpgradable != null">
        <v-btn
          :disabled="loading || listUpgradable.length == 0"
          @click="startUpgrade"
        >
          {{loading ? $t("system.update.upgrading") : $t("system.update.start-upgrade")}}
          <v-icon>play_arrow</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UpdatePage",
  data: () => ({
    loading: false,
    refresher: null,
    error: null,
    counter: 0,
    status: "Check for update...",
    headers: [
      { text: "Status", value: "status", sortable: false },
      { text: "Package", value: "name" },
      { text: "Current Version", value: "old" },
      { text: "New Version", value: "new" }
    ]
  }),
  computed: {
    ...mapState("update", ["listUpgradable"])
  },
  methods: {
    buttonUpgradeText() {
      return this.$t("system.update.start-upgrade");
    },
    iconByStatus(status) {
      if (status == "upgrading") {
        return "trending_up";
      }
      if (status == "upgradable") {
        return "sync";
      }
      if (status == "upgraded") {
        return "done";
      }
      return "alert";
    },

    getStatusUpgrade() {
      this.$store.dispatch("update/getStatusUpgrade");
    },
    startUpdate() {
      this.counter = 0;
      this.loading = true;
      this.$store
        .dispatch("update/startUpdate")
        .then((result) => {
          console.log("Result update: ", result);
          this.refresher = setInterval(() => {
            console.log("Refresh status update");
            this.counter++;
            if (this.counter > 60000 / 500) {
              this.loading = false;
              clearInterval(this.refresher);
            } else {
              this.$store
                .dispatch("update/getStatusUpdate")
                .then(data => {
                  console.log("Result from status service: ", data);
                  if (data.progress instanceof Array && data.progress.find(item => item.includes("Collected errors"))) {
                    this.loading = false;
                    this.error = true;
                  }
                  else if (data.status == "completed") {
                    clearInterval(this.refresher);
                    this.$store
                      .dispatch("update/getListUpgradable")
                      .then(() => {
                        this.loading = false;
                      })
                      .catch(e => {
                        this.loading = false;
                      });
                  }
                })
                .catch(e => {
                  this.loading = false;
                });
            }
          }, 500);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    startUpgrade() {
      this.counter = 0;
      this.loading = true;
      this.$store.dispatch("update/startUpgrade").then(() => {
        this.refresher = setInterval(() => {
          console.log("Refresh status upgrade");
          this.counter++;
          if (this.counter > 100) {
            this.loading = false;
            clearInterval(this.refresher);
          } else {
            this.$store.dispatch("update/getStatusUpgrade").then(data => {
              console.log("Result from status service upgrade: ", data);
              if (data.status == "completed") {
                this.loading = false;
                clearInterval(this.refresher);
              }
            });
          }
        }, 500);
      });
    }
  },
  mounted() {
    this.startUpdate();
  }
};
</script>

<style scoped>
</style>